import { InputField } from "@risalabs_frontend_org/oasis-ui-kit";

import type { SourceSuggestion } from "../utils/historicNarSourceUtils";

interface SourceConfirmationFieldsProps {
  sourceText: string;
  suggestions: SourceSuggestion[];
  onChange: (value: string) => void;
}

/** Confirmed source input and suggestions that preserve input focus. */
const SourceConfirmationFields = ({
  sourceText,
  suggestions,
  onChange,
}: SourceConfirmationFieldsProps) => (
  <div>
    <InputField
      id="confirmed-source"
      label="Confirmed source"
      size="md"
      fullWidth
      required
      value={sourceText}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Type the confirmed source, or pick a suggestion below"
    />
    {suggestions.length > 0 && (
      <>
        <div className="mb-2 mt-3 text-tiny font-normal tracking-wider text-[#6b7380]">
          Suggested sources — click to fill:
        </div>
        <div className="flex flex-wrap gap-2">
          {suggestions.map((suggestion) => {
            const active = sourceText === suggestion.source;
            return (
              <button
                key={suggestion.source}
                type="button"
                // Keep focus in the input so blur validation does not run before click-to-fill.
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => {
                  onChange(suggestion.source);
                }}
                className={`rounded-full px-3 py-1.5 text-sm transition-colors ${
                  active
                    ? "border-[1.5px] border-[#2673F2] font-bold text-[#2673F2]"
                    : "border border-primaryGray-14 font-medium text-primaryGray-1 hover:bg-primaryGray-16"
                }`}
              >
                {suggestion.source} ({suggestion.percent}%)
              </button>
            );
          })}
        </div>
      </>
    )}
  </div>
);

export default SourceConfirmationFields;
